// import { createApp } from 'vue';
// import { createPinia } from 'pinia';

import { createApp, pinia } from './vue';

import NewsOverview from './vue/apps/news-overview';

//const pinia = createPinia();

const articleOverviewMountingContainer = document.getElementById('js-news-overview');

if (articleOverviewMountingContainer) {
    createApp(NewsOverview).use(pinia).mount(articleOverviewMountingContainer);
}
